import React, { useCallback, useRef } from 'react';
import Sidebar from './Sidebar';
import MobileNav from '../MobileNav';
import NotificationBell from '../NotificationBell';
import './Layout.css';

const Layout = ({
  children,
  currentView,
  setCurrentView,
  user,
  onLogout,
  navigation,
  hideSidebar,
  sidebarOpen = true,
  onToggleSidebar,
  sidebarWidth = 260,
  onResizeSidebar,
  sidebarCollapsed = false,
  onToggleCollapse,
  isAdmin,
  isDeveloper,
  onNavigate,
}) => {
  const resizingRef = useRef({ active: false, startX: 0, startWidth: sidebarWidth });

  const handleResizeStart = useCallback((event) => {
    if (!onResizeSidebar) return;
    resizingRef.current = {
      active: true,
      startX: event.clientX,
      startWidth: sidebarWidth,
    };

    const handleMove = (moveEvent) => {
      if (!resizingRef.current.active) return;
      const delta = moveEvent.clientX - resizingRef.current.startX;
      onResizeSidebar(resizingRef.current.startWidth + delta);
    };

    const handleUp = () => {
      resizingRef.current.active = false;
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleUp);
    };

    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
  }, [onResizeSidebar, sidebarWidth]);

  return (
    <div
      className={`layout ${!sidebarOpen && !hideSidebar ? 'layout--sidebar-closed' : ''}`}
      style={{ '--sidebar-width': `${sidebarWidth}px` }}
    >
      {!hideSidebar && (
        <>
          {!sidebarOpen && (
            <button
              className="layout__open-button"
              type="button"
              aria-label="Open sidebar"
              onClick={onToggleSidebar}
              title="Open sidebar"
            >
              ☰
            </button>
          )}
          <Sidebar
            currentView={currentView}
            setCurrentView={setCurrentView}
            user={user}
            onLogout={onLogout}
            navigation={navigation}
            sidebarOpen={sidebarOpen}
            onToggleSidebar={onToggleSidebar}
            sidebarCollapsed={sidebarCollapsed}
            onToggleCollapse={onToggleCollapse}
          />
          {sidebarOpen && !sidebarCollapsed && (
            <div
              className="layout__resizer"
              role="separator"
              aria-orientation="vertical"
              aria-label="Resize sidebar"
              onMouseDown={handleResizeStart}
            />
          )}
          {sidebarOpen && (
            <button
              className="layout__overlay"
              type="button"
              aria-label="Close sidebar"
              onClick={onToggleSidebar}
            />
          )}
        </>
      )}
      <main className={hideSidebar ? 'layout__main layout__main--full' : 'layout__main'}>
        {!hideSidebar && (
          <div className="layout__topbar">
            <NotificationBell onNavigate={onNavigate || setCurrentView} />
          </div>
        )}
        {children}
      </main>
      {/* Mobile bottom tab bar — hidden on desktop via CSS */}
      {!hideSidebar && (
        <MobileNav
          currentView={currentView}
          onNavigate={setCurrentView}
          isAdmin={isAdmin}
          isDeveloper={isDeveloper}
        />
      )}
    </div>
  );
};

export default Layout;
